import React from 'react'
import Image from '../../../../assets/products/bolster.webp'

const OneSeatOneBack = () => {
  return (
    <svg
      width="762"
      height="498"
      viewBox="0 -150 500 450"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <image x="0" y="-150" width="611" height="385" xlinkHref={Image} />
      <g id="Group 1496">
        <g id="B-Comp">
          <g filter="url(#filter0_d_5410_1930)">
            <rect
              id="B-Background"
              x="30"
              y="37.5"
              width="41"
              height="41"
              rx="20.5"
              fill="transparent"
            />
            <path
              id="B-Text"
              d="M50.9043 58.8831H47.6172L47.5996 57.0726H50.3594C50.8457 57.0726 51.2441 57.011 51.5547 56.888C51.8652 56.7591 52.0967 56.5745 52.249 56.3343C52.4072 56.0882 52.4863 55.7894 52.4863 55.4378C52.4863 55.0394 52.4102 54.7171 52.2578 54.471C52.1113 54.2249 51.8799 54.0462 51.5635 53.9349C51.2529 53.8235 50.8516 53.7679 50.3594 53.7679H48.5312V64.4993H45.8945V51.7025H50.3594C51.1035 51.7025 51.7686 51.7728 52.3545 51.9134C52.9463 52.054 53.4473 52.2679 53.8574 52.555C54.2676 52.8421 54.5811 53.2054 54.7979 53.6448C55.0146 54.0784 55.123 54.5941 55.123 55.1917C55.123 55.7191 55.0029 56.2054 54.7627 56.6507C54.5283 57.096 54.1562 57.4593 53.6465 57.7405C53.1426 58.0218 52.4834 58.1771 51.6689 58.2064L50.9043 58.8831ZM50.79 64.4993H46.8965L47.9248 62.4427H50.79C51.2529 62.4427 51.6309 62.3694 51.9238 62.223C52.2168 62.0706 52.4336 61.8655 52.5742 61.6077C52.7148 61.3499 52.7852 61.054 52.7852 60.72C52.7852 60.345 52.7207 60.0198 52.5918 59.7444C52.4687 59.4691 52.2695 59.2581 51.9941 59.1116C51.7187 58.9593 51.3555 58.8831 50.9043 58.8831H48.3643L48.3818 57.0726H51.5459L52.1523 57.7845C52.9316 57.7728 53.5586 57.9105 54.0332 58.1976C54.5137 58.4788 54.8623 58.845 55.0791 59.2962C55.3018 59.7474 55.4131 60.2308 55.4131 60.7464C55.4131 61.5667 55.2344 62.2581 54.877 62.8206C54.5195 63.3773 53.9951 63.7962 53.3037 64.0775C52.6182 64.3587 51.7803 64.4993 50.79 64.4993Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="B-Line"
            d="M87.3536 0.646447C87.1583 0.451184 86.8417 0.451184 86.6464 0.646447L83.4645 3.82843C83.2692 4.02369 83.2692 4.34027 83.4645 4.53553C83.6597 4.7308 83.9763 4.7308 84.1716 4.53553L87 1.70711L89.8284 4.53553C90.0237 4.7308 90.3403 4.7308 90.5355 4.53553C90.7308 4.34027 90.7308 4.02369 90.5355 3.82843L87.3536 0.646447ZM86.6464 115.354C86.8417 115.549 87.1583 115.549 87.3536 115.354L90.5355 112.172C90.7308 111.976 90.7308 111.66 90.5355 111.464C90.3403 111.269 90.0237 111.269 89.8284 111.464L87 114.293L84.1716 111.464C83.9763 111.269 83.6597 111.269 83.4645 111.464C83.2692 111.66 83.2692 111.976 83.4645 112.172L86.6464 115.354ZM86.5 1V3.59091H87.5V1H86.5ZM86.5 8.77273V13.9545H87.5V8.77273H86.5ZM86.5 19.1364V24.3182H87.5V19.1364H86.5ZM86.5 29.5V34.6818H87.5V29.5H86.5ZM86.5 39.8636V45.0455H87.5V39.8636H86.5ZM86.5 50.2273V55.4091H87.5V50.2273H86.5ZM86.5 60.5909V65.7727H87.5V60.5909H86.5ZM86.5 70.9545V76.1364H87.5V70.9545H86.5ZM86.5 81.3182V86.5H87.5V81.3182H86.5ZM86.5 91.6818V96.8636H87.5V91.6818H86.5ZM86.5 102.045V107.227H87.5V102.045H86.5ZM86.5 112.409V115H87.5V112.409H86.5Z"
            fill="#FFFFFF99"
          />
        </g>
        <g id="A-Comp">
          <g filter="url(#filter1_d_5410_1930)">
            <rect
              id="A-Background"
              x="312.534"
              y="185.92"
              width="41"
              height="41"
              rx="20.5"
              transform="rotate(-97.3292 312.534 185.92)"
              fill="transparent"
            />
            <path
              id="A-Text"
              d="M330.552 158.864L327.071 169.473L324.268 169.473L329.022 156.676L330.807 156.676L330.552 158.864ZM333.443 169.473L329.954 158.864L329.673 156.676L331.475 156.676L336.256 169.473L333.443 169.473ZM333.285 164.709L333.285 166.775L326.526 166.775L326.526 164.709L333.285 164.709Z"
              fill="#FFFFFF99"
            />
          </g>
          <path
            id="A-Line"
            d="M164.813 147.094C164.644 147.313 164.685 147.627 164.903 147.796L168.465 150.546C168.684 150.715 168.998 150.674 169.167 150.456C169.335 150.237 169.295 149.923 169.076 149.754L165.91 147.31L168.355 144.144C168.524 143.925 168.483 143.611 168.265 143.442C168.046 143.274 167.732 143.314 167.563 143.533L164.813 147.094ZM486.378 106.447C486.547 106.229 486.506 105.915 486.288 105.746L482.726 102.996C482.507 102.827 482.193 102.868 482.025 103.086C481.856 103.305 481.896 103.619 482.115 103.787L485.281 106.232L482.837 109.398C482.668 109.617 482.708 109.931 482.927 110.099C483.145 110.268 483.459 110.228 483.628 110.009L486.378 106.447ZM165.273 147.896L167.779 147.574L167.651 146.582L165.145 146.904L165.273 147.896ZM172.791 146.929L177.803 146.284L177.675 145.292L172.663 145.937L172.791 146.929ZM182.815 145.64L187.827 144.995L187.7 144.003L182.687 144.648L182.815 145.64ZM192.839 144.35L197.851 143.706L197.724 142.714L192.712 143.359L192.839 144.35ZM202.863 143.061L207.875 142.416L207.748 141.425L202.736 142.069L202.863 143.061ZM212.888 141.772L217.9 141.127L217.772 140.135L212.76 140.78L212.888 141.772ZM222.912 140.482L227.924 139.838L227.796 138.846L222.784 139.491L222.912 140.482ZM232.936 139.193L237.948 138.548L237.82 137.557L232.808 138.201L232.936 139.193ZM242.96 137.904L247.972 137.259L247.845 136.267L242.833 136.912L242.96 137.904ZM252.984 136.614L257.996 135.97L257.869 134.978L252.857 135.623L252.984 136.614ZM263.008 135.325L268.021 134.68L267.893 133.689L262.881 134.333L263.008 135.325ZM273.033 134.036L278.045 133.391L277.917 132.399L272.905 133.044L273.033 134.036ZM283.057 132.746L288.069 132.102L287.941 131.11L282.929 131.755L283.057 132.746ZM293.081 131.457L298.093 130.812L297.965 129.821L292.953 130.465L293.081 131.457ZM303.105 130.168L308.117 129.523L307.99 128.531L302.978 129.176L303.105 130.168ZM313.129 128.878L318.141 128.234L318.014 127.242L313.002 127.887L313.129 128.878ZM323.153 127.589L328.166 126.944L328.038 125.953L323.026 126.597L323.153 127.589ZM333.178 126.3L338.19 125.655L338.062 124.663L333.05 125.308L333.178 126.3ZM343.202 125.011L348.214 124.366L348.086 123.374L343.074 124.019L343.202 125.011ZM353.226 123.721L358.238 123.077L358.111 122.085L353.098 122.729L353.226 123.721ZM363.25 122.432L368.262 121.787L368.135 120.795L363.123 121.44L363.25 122.432ZM373.274 121.143L378.286 120.498L378.159 119.506L373.147 120.151L373.274 121.143ZM383.299 119.853L388.311 119.209L388.183 118.217L383.171 118.861L383.299 119.853ZM393.323 118.564L398.335 117.919L398.207 116.927L393.195 117.572L393.323 118.564ZM403.347 117.275L408.359 116.63L408.231 115.638L403.219 116.283L403.347 117.275ZM413.371 115.985L418.383 115.341L418.256 114.349L413.243 114.993L413.371 115.985ZM423.395 114.696L428.407 114.051L428.28 113.059L423.268 113.704L423.395 114.696ZM433.419 113.407L438.431 112.762L438.304 111.77L433.292 112.415L433.419 113.407ZM443.444 112.117L448.456 111.473L448.328 110.481L443.316 111.125L443.444 112.117ZM453.468 110.828L458.48 110.183L458.352 109.191L453.34 109.836L453.468 110.828ZM463.492 109.539L468.504 108.894L468.376 107.902L463.364 108.547L463.492 109.539ZM473.516 108.249L478.528 107.605L478.401 106.613L473.389 107.257L473.516 108.249ZM483.54 106.96L486.046 106.638L485.919 105.646L483.413 105.968L483.54 106.96Z"
            fill="#FFFFFF99"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_5410_1930"
          x="0"
          y="17.5"
          width="101"
          height="101"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5410_1930" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5410_1930"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_5410_1930"
          x="277.304"
          y="120.025"
          width="105.896"
          height="105.895"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="10" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_5410_1930" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5410_1930"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default OneSeatOneBack
